<template>

    <div class="container">
        <div class="handle-box-search">

            <el-row class="head-search">
                <el-col :span="8">
                    <span class="title" style="min-width: 100px">被扫码人手机号:</span>

                    <el-input
                            v-model="search_data.consumer_phone"
                            placeholder="请输入被扫码人手机号 "
                            class="handle-input mr10"
                            maxlength="11"
                            @keyup.enter.native="searchconsumerScancodeLists"
                    ></el-input>
                </el-col>

                <el-col :span="8">
                    <span class="title" style="min-width: 100px">扫码人手机号:</span>
                    
                    <el-input
                            v-model="search_data.scan_consumer_phone"
                            placeholder="请输入扫码人手机号 "
                            class="handle-input mr10"
                            maxlength="11"
                            @keyup.enter.native="searchconsumerScancodeLists"
                    ></el-input>
                </el-col>

            </el-row>

            <el-row class="head-search">
                <el-col :span="8">

                    <span class="title" style="min-width: 100px">订单编码:</span>
                    <!-- 搜索手机号码 -->
                    <el-input
                            v-model="search_data.billno"
                            placeholder="请输入订单编码"
                            class="handle-input mr10"
                            @keyup.enter.native="searchconsumerScancodeLists"
                    ></el-input>
                </el-col>

            </el-row>

            <el-button
                    type="primary"
                    icon="el-icon-search"
                    @click="searchconsumerScancodeLists"
            >搜索</el-button>
            <el-button
                    icon="el-icon-refresh-right"
                    @click="refresh"
            >刷新</el-button>

        </div>
        <!-- 表格 -->
        <el-table
                :data="tableData"
                style="width: 100%"
                ref="multipleTable"
                header-cell-class-name="table-header"
        >




            <el-table-column
                    prop="consumer_name"
                    label="被扫码人"
                    min-width="150"
            >
            </el-table-column>

            <el-table-column
                    prop="consumer_phone"
                    label="被扫码人电话"
                    min-width="150"
            >
            </el-table-column>

            <el-table-column
                    prop="scan_consumer_name"
                    label="扫码人"
                    min-width="150"
            >
            </el-table-column>
            <el-table-column
                    prop="scan_consumer_phone"
                    label="扫码人电话"
                    min-width="150"
            >
            </el-table-column>

            <el-table-column
                    prop="company_commitment_moeny"
                    label="公司承担金额"
                    min-width="80"
            >
            </el-table-column>

            <el-table-column
                    prop="driver_commitment_money"
                    label="司机承担金额"
                    min-width="80"
            >
            </el-table-column>

            <el-table-column
                    prop="money"
                    label="奖励金额"
                    min-width="80"
            >
            </el-table-column>
            <el-table-column
                    prop="billno"
                    label="订单编码"
                    min-width="150"
            >
            </el-table-column>

            <el-table-column
                    prop="time.YmdHis"
                    label="时间"
                    min-width="150"
            >
            </el-table-column>


            <el-table-column label="是否下单">
                <template slot-scope="scope">
                    <el-tag :type="Number(scope.row.place_order) == 0 ? 'warning' : 'success' ">
                        {{ Number(scope.row.place_order) == 0 ? '否' : '是' }}
                    </el-tag>
                </template>
            </el-table-column>



        </el-table>

        <!-- 分页组件 -->
        <div class="pagination">
            <pages
                :search_data="search_data"
                :result_data="result_data"
                @pages_function="pages_function"
            ></pages>
        </div>

    </div>

</template>

<script>
    var _this;
    export default {

        data() {
            return {


                // 存放表格数据
                tableData: [],

                //翻页数据
                search_data: {
                    page: 1,
                    limit: 10,
                    consumer_phone: '',
                    scan_consumer_phone: '',
                    billno: ''
                },

                result_data: [],
                search_rules: {
                    page: {
                        placeholder: '页码',
                        rules: {
                            required: true,
                            message: '页码需要大于0',
                            regulation: 'gt',
                            rulesData: 0
                        }
                    },
                    limit: {
                        placeholder: '每页个数',
                        rules: {
                            required: true,
                            message: '每页个数需在1-51之内',
                            regulation: 'between',
                            rulesData: [1, 51]
                        }
                    }
                }
            };
        },
        created() {
            _this = this;
            _this.consumerScancodeLists();

        },

        methods: {
            searchconsumerScancodeLists() {
                _this.search_data.page = 1;
                _this.consumerScancodeLists();
            },
            // 搜索用户管理列表
            consumerScancodeLists() {
                _this
                    .$post('/consumer/consumerScancodeLists', _this.search_data, _this.search_rules)
                    .then((res) => {
                        // 将请求的数据存放到表格数据数组中
                        _this.tableData = res.data;
                        _this.result_data = res;
                    })
                    .catch((err) => {});
            },
            // 翻页组件的回调
            pages_function(search_data) {
                console.log(_this.search_data);

                //赋值
                _this.search_data = search_data;
                //初始化列表
                _this.consumerScancodeLists();
            },


            // 刷新按钮
            refresh() {
                this.$router.go(0);
            },


        }
    };
</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 200px;
        display: inline-block;
    }

    .table {
        width: 100%;
        font-size: 14px;
    }

    .red {
        color: #ff0000;
    }

    .mr10 {
        margin-right: 10px;
    }

    .table-td-thumb {
        display: block;
        margin: auto;
        width: 40px;
        height: 40px;
    }

    .el-table__row {
        height: 100px;
    }

    .el-dropdown {
        vertical-align: top;
    }

    .el-dropdown + .el-dropdown {
        margin-left: 15px;
    }

    .el-icon-arrow-down {
        font-size: 12px;
    }
</style>